<template>
  <div class="image-upload-info-container">
    <ul class="el-upload-list el-upload-list--picture-card">
      <draggable v-model="fileList">
        <li v-for="(item, index) in fileList" :key="item.uid" class="el-upload-list__item is-success animated">
          <img :src="item.url" alt="" class="el-upload-list__item-thumbnail" />
          <i class="el-icon-close"></i>
          <span class="el-upload-list__item-actions">
            <span class="el-upload-list__item-delete" @click="pictureRemove(fileList[index])">
              <i class="el-icon-delete"></i>
            </span>
          </span>
        </li>
      </draggable>
    </ul>
    <el-upload
      v-if="fileList.length < limit"
      ref="upload"
      :class="{ uploadContainer: hideAddDiv }"
      :action="`${env.VUE_APP_fileserver}persistentUpload`"
      list-type="picture-card"
      :limit="limit"
      :file-list="fileList"
      :show-file-list="false"
      :on-success="uploadSuccess"
      :on-remove="pictureRemove"
      :before-upload="pictureBeforeUpload"
    >
      <i class="el-icon-plus"></i>
    </el-upload>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  components: {
    draggable,
  },
  props: {
    limit: {
      type: Number,
      default: 10,
    },
    sizeLimit: {
      type: Number,
      default: 0.3,
    },
  },
  data() {
    return {
      env: process.env,
      fileList: [],
    };
  },
  computed: {
    hideAddDiv() {
      return this.fileList.length >= this.limit;
    },
  },
  methods: {
    pictureUpload(file) {
      console.log("file", file);
      console.log("this.$refs.upload", this.$refs.upload.$el.querySelector("el-upload"));
    },
    uploadSuccess(res) {
      const {
        data: { name, url },
      } = res;
      const item = {
        name: name || "",
        url: url ? `${url}?imageView2/1/w/200/h/200` : "",
      };

      this.fileList.push(item);
      console.log("上传图片成功之后", this.fileList);
    },
    pictureRemove(file) {
      this.fileList = this.fileList.filter((item) => item.uid !== file.uid);
      console.log("移除图片", this.fileList);
    },
    pictureBeforeUpload(file) {
      const typeArr = ["image/png", "image/jpg", "image/jpeg"];

      if (!typeArr.includes(file.type)) {
        this.$message.error("上传图片只能是 JPG、PNG 格式!");
        return false;
      }

      if (file.size > this.sizeLimit * 1024 * 1024) {
        let unitStr = this.sizeLimit >= 1 ? `${this.sizeLimit}M` : `${this.sizeLimit * 1000}KB`;
        this.$message.error(`图片不能大于${unitStr}`);
        return false;
      }
      this.isShowProgress = true;
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ {
  .el-icon-close-tip {
    display: none;
  }
}
.image-upload-info-container {
  display: flex;
  .uploadContainer {
    ::v-deep .el-upload--picture-card {
      display: none;
    }
  }
}
</style>
